import React from "react";

export default function Notifications() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Notifications / Announcements</h1>
      <p>Here you can create, view, and manage company-wide messages and announcements for employees.</p>

      {/* Example placeholder list */}
      <ul className="mt-4 space-y-2">
        <li className="bg-gray-700 p-2 rounded">🎉 Welcome new employees to the company!</li>
        <li className="bg-gray-700 p-2 rounded">📅 Annual HR policy update scheduled on Dec 15.</li>
        <li className="bg-gray-700 p-2 rounded">🔔 Submit your feedback for the new HR portal features.</li>
      </ul>
    </div>
  );
}
